import api from './connectionProxy'

export const getProfiles = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params

  return api.http.get('/profiles', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getFunctionalities = () => {
  return api.http.get(`/profiles/functionalities`)
}

export const getProfile = id => {
  return api.http.get(`/profiles/${id}`)
}

export const addProfile = profile => {
  return api.http.post('/profiles', profile)
}

export const editProfile = profile => {
  return api.http.put(`/profiles/${profile._id}`, profile)
}

export const deleteProfile = id => {
  return api.http.delete(`/profiles/${id}`)
}

export const restoreProfile = id => {
  return api.http.put(`/profiles/${id}/restore`)
}



// WEBPACK FOOTER //
// ./src/api/profiles.js